import React, { createContext, useEffect, useState } from "react";
import { BasketHistory, BasketHistoryDeatils } from "../../../axios";
import { useAppDispatch, useAppSelector } from "../../../store/configureStore";

export const ExistDataContext = createContext();

// BasketHistory --------- phone number
// BasketHistoryDeatils ------------- basket id

const ExistDataProvider = (props) => {
  const { user } = useAppSelector((state) => state.account);

  const [existProduct, setExistProduct] = useState([]);

  function existsInArray(id) {
    // console.log("exist products" , existProduct);
    // console.log("id id id" , id);
    return existProduct?.some((item) => item.productID === id);
  }
  // let isLoggedIn = sessionStorage.getItem("login");

  // let phoneNumber = sessionStorage.getItem("phonenumber");

  useEffect(() => {
    if (user) {
      BasketHistory(user.phone).then(({ data }) => {
        // Use Promise.all to wait for all the BasketHistoryDetails requests to finish
        let newData;
        Promise.all(data.map((item) => BasketHistoryDeatils(item.id))).then(
          (results) => {
            // Use flatMap to flatten the nested arrays of data into one array
            let newArray = results.flatMap(({ data }) => data);
            newData = results.flatMap(({ data }) => data);
            setExistProduct(newArray);
          }
        );
      });
    }
  }, [user]);

  return (
    <ExistDataContext.Provider
      value={[existProduct, setExistProduct, existsInArray]}
    >
      {props.children}
    </ExistDataContext.Provider>
  );
};

export default ExistDataProvider;
